import * as React from "react";
import { Link, NavLinkProps } from "react-router-dom";

type OwnProps = NavLinkProps & {
    icon: string;
    label?: JSX.Element | string;
};

export class IconLink extends React.Component<OwnProps, {}> {
    public render() {
        if (this.props.label)
            return <Link {...this.props}><i className={"fa fa-" + this.props.icon}></i> {this.props.label}</Link>;
        return <Link {...this.props}><i className={"fa fa-" + this.props.icon}></i></Link>;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/IconLink.tsx